export default __webpack_public_path__ + "static/media/index-header.b51b61eb.png";